import script from "./ShootingDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShootingDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ShootingDashboard.vue?vue&type=style&index=0&id=3f4d8573&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4d8573"]])

export default __exports__